var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame",
    transform: "translate(0.4 -0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30854",
    "data-name": "Path 30854",
    d: "M12.088,11.62h-.079a.528.528,0,0,0-.178,0A5.135,5.135,0,0,1,6.81,6.44a5.12,5.12,0,1,1,10.24,0,5.14,5.14,0,0,1-4.933,5.18ZM11.93,2.75a3.687,3.687,0,0,0-.138,7.37,1.607,1.607,0,0,1,.316,0,3.689,3.689,0,0,0-.178-7.37Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30855",
    "data-name": "Path 30855",
    d: "M12.1,22.55a9.719,9.719,0,0,1-5.37-1.5A4.3,4.3,0,0,1,4.6,17.5a4.343,4.343,0,0,1,2.13-3.57,10.406,10.406,0,0,1,10.74,0,4.321,4.321,0,0,1,2.13,3.55,4.343,4.343,0,0,1-2.13,3.57A9.742,9.742,0,0,1,12.1,22.55ZM7.552,15.19a2.879,2.879,0,0,0-1.466,2.32,2.872,2.872,0,0,0,1.466,2.3,8.882,8.882,0,0,0,9.1,0,2.879,2.879,0,0,0,1.466-2.32,2.872,2.872,0,0,0-1.466-2.3A8.928,8.928,0,0,0,7.552,15.19Z",
    transform: "translate(0 0.7)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8474",
    "data-name": "Rectangle 8474",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuProfile);
export default __webpack_public_path__ + "static/media/menu-profile.791371cb0689cd6439ea9ca8d9221eaf.svg";
export { ForwardRef as ReactComponent };